import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MdFilterListOff } from 'react-icons/md';
import { Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

const NoResultsToShowWarning: FC = () => {
  const { t } = useTranslation('followUp');

  return (
    <Stack direction="row" sx={styles.noResultsToShow}>
      <MdFilterListOff size={20} />
      <Typography variant="caption">{t('noResultsToShow')}</Typography>
    </Stack>
  );
};

export default NoResultsToShowWarning;
